(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  // Fisher–Yates shuffle + trim to the merchant-set limit. Runs only when
  // the section opted into shuffle (fallback to collections.all OR explicit
  // random toggle). Idempotent against editor section reload events.
  (function shuffle404() {
    const containers = document.querySelectorAll('.error-404__bestsellers--shuffle');
    if (!containers.length) return;

    const swap = (arr, i, j) => { const t = arr[i]; arr[i] = arr[j]; arr[j] = t; };

    containers.forEach((container) => {
      if (container.dataset.shuffled === 'true') return;
      const grid = container.querySelector('[data-shuffle-grid]');
      if (!grid) return;
      const items = Array.from(grid.children);
      for (let i = items.length - 1; i > 0; i--) {
        swap(items, i, Math.floor(Math.random() * (i + 1)));
      }
      const limit = parseInt(container.dataset.shuffleLimit, 10) || items.length;
      grid.replaceChildren(...items.slice(0, limit));
      container.classList.add('is-ready');
      container.dataset.shuffled = 'true';
    });
  })();


  /* Il campo della 404 apre la ricerca del sito invece di essere una
     seconda ricerca a se'. `lytta:search:open` e' l'aggancio che il
     componente della testata ascolta gia'.

     Si controlla che il cassetto ci sia davvero: se il commerciante ha
     spento la ricerca in testata non c'e' niente da aprire, e allora il
     modulo resta quello che era e manda alla pagina dei risultati. */
  (function () {
    var campo = document.querySelector('[data-404-search]');
    if (!campo) return;
    if (!document.querySelector('[data-search-drawer]')) return;

    function apri(e) {
      e.preventDefault();
      campo.blur();
      document.dispatchEvent(new CustomEvent('lytta:search:open'));
    }
    campo.addEventListener('focus', apri);
    campo.addEventListener('click', apri);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lytta-brands')) {
    class LyttaBrands extends HTMLElement {
      constructor() { super(); }

      connectedCallback() {
        this.searchInput = this.querySelector('[data-brand-search]');
        this.list = document.querySelector('[data-brand-list]');
        this.empty = document.querySelector('[data-brand-empty]');
        this.cards = this.list ? this.list.querySelectorAll('[data-brand-card]') : [];
        this.groups = this.list ? this.list.querySelectorAll('.brands-grid__group') : [];

        if (this.searchInput) {
          let timer;
          this.searchInput.addEventListener('input', (e) => {
            clearTimeout(timer);
            timer = setTimeout(() => this.filter(e.target.value), 100);
          });
        }
      }

      filter(query) {
        const q = (query || '').trim().toLowerCase();
        let visibleCount = 0;

        this.cards.forEach(card => {
          const name = card.dataset.brandName || '';
          const match = q === '' || name.includes(q);
          card.hidden = !match;
          if (match) visibleCount++;
        });

        // Hide groups that have no visible cards
        this.groups.forEach(group => {
          const visibleInGroup = group.querySelectorAll('[data-brand-card]:not([hidden])');
          group.classList.toggle('brands-grid__group--empty', visibleInGroup.length === 0);
        });

        if (this.empty) this.empty.hidden = visibleCount > 0;
      }
    }
    customElements.define('lytta-brands', LyttaBrands);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class LyttaFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
      this.categories = Array.from(this.querySelectorAll('[data-faq-category]'));
      this.searchInput = this.querySelector('[data-faq-search]');
      this.noResults = this.querySelector('[data-faq-no-results]');
      this.singleOpen = this.dataset.singleOpen === 'true';

      if (this.singleOpen) this._initSingleOpen();
      if (this.searchInput) this._initSearch();
    }

    _initSingleOpen() {
      this.items.forEach(item => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          // Close all others
          this.items.forEach(other => {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }

    _initSearch() {
      const debounced = (fn, delay) => {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn(...args), delay);
        };
      };

      this.searchInput.addEventListener('input', debounced((e) => {
        this._filter(e.target.value.trim().toLowerCase());
      }, 150));
    }

    _filter(query) {
      if (!query) {
        // Show everything
        this.items.forEach(i => i.removeAttribute('hidden'));
        this.categories.forEach(c => c.removeAttribute('hidden'));
        this.noResults?.setAttribute('hidden', '');
        return;
      }

      let visibleCount = 0;
      this.items.forEach(item => {
        const question = item.querySelector('.faq__question-text')?.textContent.toLowerCase() || '';
        const answer = item.querySelector('.faq__answer')?.textContent.toLowerCase() || '';
        const matches = question.includes(query) || answer.includes(query);
        if (matches) {
          item.removeAttribute('hidden');
          item.open = true; // auto-open matching items so the match is visible
          visibleCount++;
        } else {
          item.setAttribute('hidden', '');
          item.open = false;
        }
      });

      // Hide a category if all its following items (up to next category) are hidden
      this.categories.forEach((cat, idx) => {
        const nextCat = this.categories[idx + 1];
        let catHasVisible = false;
        let sibling = cat.nextElementSibling;
        while (sibling && sibling !== nextCat) {
          if (sibling.matches?.('[data-faq-item]') && !sibling.hasAttribute('hidden')) {
            catHasVisible = true;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
        if (catHasVisible) cat.removeAttribute('hidden');
        else cat.setAttribute('hidden', '');
      });

      // No-results message
      if (visibleCount === 0 && this.noResults) {
        this.noResults.removeAttribute('hidden');
      } else {
        this.noResults?.setAttribute('hidden', '');
      }
    }
  }
  customElements.define('lytta-faq', LyttaFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* Barra di avanzamento del carosello.

     Legge solo `scrollLeft` dentro un rAF: nessuna misura nel gestore dello
     scroll, che su un telefono viene chiamato a ogni frame. Se questo codice
     non parte la barra resta piena e il carosello scorre lo stesso: e' un
     indicatore, non un comando. */
  (function () {
    document.querySelectorAll('[data-fc-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-fc-track]');
      var bar = wrap.querySelector('[data-fc-progress]');
      if (!track || !bar) return;

      var ticking = false;
      function update() {
        ticking = false;
        var scorribile = track.scrollWidth - track.clientWidth;
        if (scorribile <= 1) {
          bar.style.setProperty('--fc-progress-width', '100%');
          bar.style.setProperty('--fc-progress-left', '0%');
          return;
        }
        var visibile = track.clientWidth / track.scrollWidth;
        var avanzamento = track.scrollLeft / scorribile;
        var larghezza = Math.max(visibile * 100, 12);
        bar.style.setProperty('--fc-progress-width', larghezza.toFixed(2) + '%');
        bar.style.setProperty('--fc-progress-left', (avanzamento * (100 - larghezza)).toFixed(2) + '%');
      }

      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });

      /* ---- frecce ---- */
      var prev = wrap.querySelector('[data-fc-prev]');
      var next = wrap.querySelector('[data-fc-next]');

      function passo() {
        var primo = track.querySelector('.product-grid__item');
        /* Un elemento per clic, non una schermata: su una griglia da quattro
           saltare quattro schede fa perdere il filo di dove si era. */
        return primo ? primo.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      function aggiornaFrecce() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -passo(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: passo(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', aggiornaFrecce, { passive: true });
      window.addEventListener('resize', aggiornaFrecce, { passive: true });

      /* ---- trascinamento ---- */
      if (wrap.hasAttribute('data-fc-drag')) {
        var giu = false, partenzaX = 0, partenzaScroll = 0, mosso = 0;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;   // il dito lo fa gia' il browser
          giu = true; mosso = 0;
          partenzaX = e.clientX;
          partenzaScroll = track.scrollLeft;
        });
        track.addEventListener('pointermove', function (e) {
          if (!giu) return;
          var delta = e.clientX - partenzaX;
          mosso = Math.abs(delta);
          /* Sotto la soglia non e' un trascinamento: e' un clic un po'
             tremolante, e rubarlo impedirebbe di aprire la scheda. */
          if (mosso < 5) return;
          track.classList.add('is-dragging');
          track.scrollLeft = partenzaScroll - delta;
        });
        function fine(e) {
          if (!giu) return;
          giu = false;
          track.classList.remove('is-dragging');
          if (mosso >= 5 && e) {
            /* Il pointerup dopo un trascinamento non deve diventare un clic
               sul link della scheda che sta sotto al dito. */
            var blocca = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
            track.addEventListener('click', blocca, { capture: true, once: true });
            window.setTimeout(function () {
              track.removeEventListener('click', blocca, { capture: true });
            }, 0);
          }
        }
        track.addEventListener('pointerup', fine);
        track.addEventListener('pointerleave', fine);
        track.addEventListener('pointercancel', fine);
      }

      /* ---- scorrimento automatico ---- */
      var secondi = parseFloat(wrap.getAttribute('data-fc-autoplay') || '0');
      var lento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (secondi > 0 && !lento) {
        var timer = null;
        function avanza() {
          var max = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= max - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: passo(), behavior: 'smooth' });
          }
        }
        function avvia() { if (!timer) timer = window.setInterval(avanza, secondi * 1000); }
        function ferma() { if (timer) { window.clearInterval(timer); timer = null; } }
        wrap.addEventListener('mouseenter', ferma);
        wrap.addEventListener('mouseleave', avvia);
        wrap.addEventListener('focusin', ferma);
        wrap.addEventListener('focusout', avvia);
        /* Fermo anche quando la sezione non e' in schermo: un carosello che
           gira in fondo alla pagina consuma batteria per nessuno. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (voci) {
            voci.forEach(function (v) { v.isIntersecting ? avvia() : ferma(); });
          }, { threshold: 0.2 }).observe(wrap);
        } else {
          avvia();
        }
      }

      update();
      aggiornaFrecce();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Footer mobile accordion — when `mobile_collapse_menus` is ON, strip
     the `open` attribute from each <details> on mobile viewports so the
     menus start collapsed. On desktop the `open` attribute stays so the
     menus render as a flat layout (CSS keeps them visually open).
     Also sync on resize so a merchant rotating between portrait/landscape
     in the editor preview gets the right state. */
  (function initFooterMobileAccordion() {
    const footer = document.querySelector('.footer--mobile-collapse-menus');
    if (!footer) return;
    const detailsList = footer.querySelectorAll('.footer__menu-details');
    if (!detailsList.length) return;

    const mq = window.matchMedia('(max-width: 640px)');
    const apply = () => {
      detailsList.forEach(d => {
        if (mq.matches) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
    };
    apply();
    mq.addEventListener?.('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Dropdown hover for desktop
  document.querySelectorAll('.header__nav-item--has-dropdown').forEach(item => {
    // Con la macrovoce cliccabile il comando che apre e' la freccia, non il
    // nome: il nome e' un link e deve poter navigare.
    const btn = item.querySelector('.header__nav-caret') || item.querySelector('.header__nav-link--dropdown');
    const dropdown = item.querySelector('.header__dropdown, .mega-menu');

    if (!btn || !dropdown) return;

    item.addEventListener('mouseenter', () => {
      btn.setAttribute('aria-expanded', 'true');
      dropdown.removeAttribute('hidden');
    });

    item.addEventListener('mouseleave', () => {
      btn.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('hidden', '');
    });

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      dropdown.toggleAttribute('hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-break"] && !Shopify.designMode) return;
  try {
    
  /* Parallax for [data-image-break-parallax].
     Everything is measured inside a rAF callback, never in the scroll
     handler itself. An IntersectionObserver keeps the scroll listener
     detached whenever no image break is on screen, so a page without one
     visible pays nothing. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var frames = Array.prototype.slice.call(
      document.querySelectorAll('[data-image-break-parallax]')
    );
    if (!frames.length) return;

    var visible = [];
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      visible.forEach(function (el) {
        var img = el.querySelector('.image-break__img');
        if (!img) return;
        var rect = el.getBoundingClientRect();
        var shift = parseFloat(el.dataset.parallaxStrength || '40');
        el.style.setProperty('--ib-shift', shift + 'px');
        /* -1 when the frame sits just below the fold, +1 just above it. */
        var progress = ((rect.top + rect.height / 2) - vh / 2) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        img.style.transform = 'translate3d(0,' + (progress * shift * -1).toFixed(2) + 'px,0)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = visible.indexOf(entry.target);
        if (entry.isIntersecting && i === -1) visible.push(entry.target);
        if (!entry.isIntersecting && i !== -1) visible.splice(i, 1);
      });
      if (visible.length) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    }, { rootMargin: '10% 0px' });

    frames.forEach(function (el) { io.observe(el); });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  class LyttaCustomerAddresses extends HTMLElement {
    connectedCallback() {
      // Toggle "new address" form
      const newForm = this.querySelector('[data-new-address-form]');
      this.querySelectorAll('[data-toggle-new-address]').forEach(btn => {
        btn.addEventListener('click', () => {
          newForm?.toggleAttribute('hidden');
          if (!newForm?.hasAttribute('hidden')) {
            newForm.querySelector('input, select')?.focus();
            newForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // Toggle edit mode for each address
      this.querySelectorAll('[data-edit-address]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.editAddress;
          this.showEdit(id);
        });
      });

      this.querySelectorAll('[data-cancel-edit]').forEach(btn => {
        btn.addEventListener('click', () => this.showDisplay(btn.dataset.cancelEdit));
      });

      // Delete confirmation
      this.querySelectorAll('[data-confirm]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          if (!confirm(btn.dataset.confirm)) e.preventDefault();
        });
      });

      // Init country/province selectors using Shopify's helper if available
      this.initCountrySelectors();
    }

    showEdit(id) {
      const addr = this.querySelector(`[data-address-id="${id}"]`);
      addr?.querySelector('[data-address-display]')?.setAttribute('hidden', '');
      addr?.querySelector(`[data-address-edit="${id}"]`)?.removeAttribute('hidden');
    }

    showDisplay(id) {
      const addr = this.querySelector(`[data-address-id="${id}"]`);
      addr?.querySelector(`[data-address-edit="${id}"]`)?.setAttribute('hidden', '');
      addr?.querySelector('[data-address-display]')?.removeAttribute('hidden');
    }

    initCountrySelectors() {
      // Shopify exposes window.Shopify.CountryProvinceSelector when the
      // country_option_tags / address_country_option_tags are rendered.
      if (typeof Shopify === 'undefined' || !Shopify.CountryProvinceSelector) return;

      this.querySelectorAll('[data-country-selector]').forEach(select => {
        const provinceSelector = select.dataset.countrySelector; // ID of province select
        new Shopify.CountryProvinceSelector(select.id, provinceSelector, {
          hideElement: select.dataset.provinceContainer
        });
      });
    }
  }
  customElements.define('lytta-customer-addresses', LyttaCustomerAddresses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // Share — copy link button
  (function () {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-share-copy]');
      if (!btn) return;
      e.preventDefault();
      const url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          btn.classList.add('is-copied');
          setTimeout(() => btn.classList.remove('is-copied'), 1500);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-remove-page-item]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`[data-qty-page-input="${btn.dataset.removePageItem}"]`);
      if (input) { input.value = 0; document.getElementById('CartPageForm')?.submit(); }
    });
  });

  document.querySelectorAll('[data-qty-page-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`[data-qty-page-input="${btn.dataset.qtyPageMinus}"]`);
      if (input && parseInt(input.value) > 0) input.value = parseInt(input.value) - 1;
    });
  });

  document.querySelectorAll('[data-qty-page-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`[data-qty-page-input="${btn.dataset.qtyPagePlus}"]`);
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ============== Sort dropdown ============== */
  document.querySelector('[data-sort-select]')?.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ============== Sort tabs ============== */
  document.querySelectorAll('[data-sort-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', btn.dataset.sortValue);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ============== Filter checkboxes (incl. tile checkbox) ============== */
  document.querySelectorAll('[data-filter-input]').forEach(input => {
    input.addEventListener('change', () => {
      const form = document.getElementById('FiltersForm');
      /* Dentro una finestra ricaricare a ogni spunta vuol dire chiuderla in
         faccia a chi la sta usando: le spunte si accumulano e partono tutte
         insieme con "Applica filtri". */
      if (form && form.hasAttribute('data-filters-deferred')) return;
      const params = new URLSearchParams(new FormData(form));
      const url = new URL(window.location.pathname, window.location.origin);
      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  /* ============== Horizontal filter bar: dropdown behaviour ==============
     Only runs when the merchant chose the `bar` layout. Native <details>
     already opens and closes on its own; what it does NOT do is close when
     you click elsewhere, or close its siblings — and a row of dropdowns
     that all stay open at once covers the grid they are meant to filter.

     The listeners sit on `document` rather than on each <summary> so a
     theme-editor re-render of the section keeps working. */
  (function initFilterBar() {
    const layout = document.querySelector('.collection-layout--bar');
    if (!layout) return;

    const groups = () => layout.querySelectorAll('details.collection-filters__group');
    const closeAll = (except) => {
      groups().forEach(d => { if (d !== except) d.open = false; });
    };

    // Desktop only: below 1025px the same markup is the mobile drawer, where
    // several open groups at once is the expected behaviour.
    const isBar = () => window.matchMedia('(min-width: 1025px)').matches;

    layout.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!isBar()) return;
      if (d.tagName === 'DETAILS' && d.open) closeAll(d);
    }, true);

    document.addEventListener('click', (e) => {
      if (!isBar()) return;
      if (e.target.closest('.collection-filters__group')) return;
      closeAll(null);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !isBar()) return;
      const open = layout.querySelector('details.collection-filters__group[open]');
      if (!open) return;
      open.open = false;
      const summary = open.querySelector('summary');
      if (summary) summary.focus();
    });
  })();

  /* ============== Mobile filters toggle ==============
     Click the mobile-only toggle button to expand/collapse the sidebar.
     Event delegation on `document` so it works even after Shopify
     re-renders the section in the theme editor (the listener is on the
     persistent root, not on the button itself). `closest()` catches
     clicks on the button's inner spans (label, count, icon). */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-toggle-filters]');
    if (!btn) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls') || 'CollectionFilters');
    if (!panel) return;
    const isOpen = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    sincronizzaSfondo(isOpen);
  });

  /* ============== Filtri a finestra ==============
     Lo sfondo scuro, la chiusura e l'applicazione differita. Tutto legato
     con la delega sul documento, cosi' continua a funzionare quando
     l'editor del tema ridisegna la sezione. */
  function pannelloFiltri() {
    return document.querySelector('.collection-layout--panel .collection-filters');
  }

  function sincronizzaSfondo(aperto) {
    const sfondo = document.querySelector('[data-filters-backdrop]');
    if (!sfondo) return;
    if (aperto) {
      sfondo.hidden = false;
      // Si forza il calcolo del layout per separare i due stati: senza,
      // il browser li accorpa e la dissolvenza non parte. Sincrono, a
      // differenza di requestAnimationFrame, che in una scheda in secondo
      // piano non viene chiamato affatto.
      void sfondo.offsetHeight;
      sfondo.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    } else {
      sfondo.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => { if (!sfondo.classList.contains('is-open')) sfondo.hidden = true; }, 300);
    }
  }

  function chiudiFiltri() {
    const p = pannelloFiltri();
    if (!p || !p.classList.contains('is-open')) return;
    p.classList.remove('is-open');
    document.querySelectorAll('[data-toggle-filters]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    sincronizzaSfondo(false);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-close-filters]') || e.target.closest('[data-filters-backdrop]')) {
      chiudiFiltri();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') chiudiFiltri();
  });

  /* "Applica filtri": raccoglie tutte le spunte in una volta sola. */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-apply-filters]')) return;
    const form = document.getElementById('FiltersForm');
    if (!form) return;
    const params = new URLSearchParams(new FormData(form));
    const url = new URL(window.location.pathname, window.location.origin);
    url.search = params.toString();
    window.location.href = url.toString();
  });

  /* Filters drawer JS removed — the sidebar is now always inline on every
     viewport, no open/close behaviour needed. Defensively clear any
     stale aria-hidden / inline overflow lock from older sessions. */
  (function clearStaleFiltersDrawer() {
    const panel = document.getElementById('CollectionFilters');
    if (panel) panel.removeAttribute('aria-hidden');
    /* NON si cancella piu' `.collection-filters-backdrop`: oggi quel
       selettore e' lo sfondo del pannello dei filtri, non il residuo del
       vecchio cassetto, e questa riga lo toglieva dal DOM un istante dopo
       che il tema l'aveva stampato. */
    if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
  })();

  /* ============== View toggle (grid density) ============== */
  (function initViewToggle() {
    const buttons = document.querySelectorAll('.collection-view-toggle__btn');
    if (buttons.length === 0) return;
    const wrap = document.querySelector('.collection-grid-wrap');
    if (!wrap) return;

    const stored = localStorage.getItem('lytta:collection-view');
    if (stored === 'dense') {
      wrap.dataset.view = 'dense';
      buttons.forEach(b => {
        const active = b.dataset.view === 'dense';
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active);
      });
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        wrap.dataset.view = view;
        // localStorage may throw in iOS Safari private mode — non-fatal,
        // the view choice still applies in-session, just not remembered.
        try { localStorage.setItem('lytta:collection-view', view); } catch (e) { /* private mode / quota */ }
        buttons.forEach(b => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active);
        });
      });
    });
  })();

  /* ============== Tile click sync (so .is-active reflects checked state) ============== */
  document.querySelectorAll('.collection-filters__tile input').forEach(input => {
    input.addEventListener('change', (e) => {
      e.target.closest('.collection-filters__tile').classList.toggle('is-active', e.target.checked);
    });
  });

  /* ============== Load more (Section Rendering API) ============== */
  if (!customElements.get('lytta-collection-loadmore')) {
    class LyttaCollectionLoadmore extends HTMLElement {
      constructor() {
        super();
        this.btn = null;
        this.label = null;
        this.countEl = null;
        this.progressEl = null;
        this.currentPage = 1;
        this.totalPages = 1;
        this.totalProducts = 0;
        this.shownProducts = 0;
      }

      connectedCallback() {
        this.btn = this.querySelector('[data-loadmore-btn]');
        this.label = this.querySelector('[data-loadmore-label]');
        this.countEl = this.querySelector('[data-loadmore-count]');
        this.progressEl = this.querySelector('[data-loadmore-progress]');
        this.currentPage = parseInt(this.dataset.currentPage, 10) || 1;
        this.totalPages = parseInt(this.dataset.totalPages, 10) || 1;
        this.totalProducts = parseInt(this.dataset.totalProducts, 10) || 0;
        this.shownProducts = parseInt(this.dataset.shownProducts, 10) || 0;
        this.sectionId = this.dataset.sectionId;
        this.baseUrl = this.dataset.baseUrl;

        this.btn?.addEventListener('click', () => this.loadNext());
      }

      async loadNext() {
        if (this.currentPage >= this.totalPages) return;
        this.dataset.loading = 'true';
        const nextPage = this.currentPage + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', nextPage);
        url.searchParams.set('section_id', this.sectionId);

        try {
          const res = await fetch(url.toString());
          if (!res.ok) throw new Error('Network');
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('#CollectionGrid');
          const currentGrid = document.getElementById('CollectionGrid');
          if (!newGrid || !currentGrid) throw new Error('Grid not found');

          // Append new product items (not promo tiles — promo positions are absolute)
          newGrid.querySelectorAll('.product-grid__item:not(.product-grid__item--promo)').forEach(item => {
            currentGrid.appendChild(item);
          });

          this.currentPage = nextPage;
          this.shownProducts = Math.min(this.shownProducts + newGrid.children.length, this.totalProducts);

          // Update progress and count
          const progressPct = Math.round((this.shownProducts / this.totalProducts) * 100);
          if (this.progressEl) this.progressEl.style.setProperty('--progress', progressPct + '%');
          if (this.countEl) {
            const tpl = this.dataset.countTemplate || '[shown] / [total]';
            this.countEl.textContent = tpl
              .replace(/\[shown\]/g, this.shownProducts)
              .replace(/\[total\]/g, this.totalProducts);
          }

          // Trigger reveal animations on new cards
          if (typeof window.initAnimations === 'function') window.initAnimations();

          // Hide if at end
          if (this.currentPage >= this.totalPages) {
            this.btn?.setAttribute('disabled', 'true');
            this.btn?.style.setProperty('display', 'none');
          }
        } catch (err) {
          console.warn('[Lytta loadmore]', err);
        } finally {
          this.dataset.loading = 'false';
        }
      }
    }
    customElements.define('lytta-collection-loadmore', LyttaCollectionLoadmore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  class LyttaCustomerAuth extends HTMLElement {
    connectedCallback() {
      this.login = this.querySelector('[data-panel-login]');
      this.recover = this.querySelector('[data-panel-recover]');

      this.querySelectorAll('[data-toggle-recover]').forEach(btn => {
        btn.addEventListener('click', () => this.toggle());
      });

      // Auto-open recover panel if hash is #recover (deep link)
      if (window.location.hash === '#recover') this.showRecover();
    }

    toggle() {
      const recoverHidden = this.recover?.hasAttribute('hidden');
      if (recoverHidden) this.showRecover();
      else this.showLogin();
    }

    showRecover() {
      this.login?.setAttribute('hidden', '');
      this.recover?.removeAttribute('hidden');
      this.recover?.querySelector('input[type="email"]')?.focus();
    }

    showLogin() {
      this.recover?.setAttribute('hidden', '');
      this.login?.removeAttribute('hidden');
    }
  }
  customElements.define('lytta-customer-auth', LyttaCustomerAuth);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class LyttaNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const signal = this._ac.signal;
      this._signal = signal;

      this.trigger = this.dataset.trigger;
      this.timerDelay = parseInt(this.dataset.timerDelay, 10) || 8000;
      this.scrollThreshold = parseInt(this.dataset.scrollThreshold, 10) || 40;
      this.frequency = this.dataset.frequency;
      this.frequencyDays = parseInt(this.dataset.frequencyDays, 10) || 7;
      this.sectionId = this.dataset.sectionId;

      this.storageKey = `lytta_newsletter_popup_${this.sectionId}`;

      this.form = this.querySelector('[data-popup-form]');
      this.discountCopyBtn = this.querySelector('[data-popup-discount-copy]');
      this.discountCode = this.querySelector('[data-popup-discount-code]')?.textContent.trim();

      // Close handlers
      this.querySelectorAll('[data-popup-close]').forEach(el => {
        el.addEventListener('click', () => this.close(true));
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close(true);
      }, { signal });

      // Discount copy
      this.discountCopyBtn?.addEventListener('click', () => this._copyDiscount());

      // Listen for manual trigger anywhere
      document.addEventListener('lytta:newsletter-popup:open', () => this.open(), { signal });

      // ----- Theme editor preview ------------------------------------------
      // Force-show the popup in the theme editor. We check both the
      // Liquid-rendered data attribute AND the live `Shopify.designMode`
      // global so the preview always works even if either signal is late.
      this._editorPreview = this.dataset.editorPreview === 'true' || window.Shopify?.designMode === true;
      if (this._editorPreview) {
        this.setAttribute('aria-hidden', 'false');
        // Make sure the editor-preview class is on the element so the CSS
        // that bypasses entry animation kicks in (Liquid adds it too, but
        // covering the JS-only path).
        this.classList.add('newsletter-popup--editor-preview');
        return;
      }

      // If frequency is "always" (test mode) always try; else check storage
      if (!this._shouldShow()) {
        return;
      }

      // Setup trigger
      switch (this.trigger) {
        case 'timer':
          this._setupTimer();
          break;
        case 'exit_intent':
          this._setupExitIntent();
          break;
        case 'scroll_depth':
          this._setupScrollDepth();
          break;
        case 'scroll_up':
          this._setupScrollUp();
          break;
        case 'manual':
          // Only opened via external dispatch of 'lytta:newsletter-popup:open'
          break;
      }

      // If form was posted successfully this page load, show the popup immediately
      if (this.querySelector('[data-popup-success]')) {
        this.open();
      }
    }

    isOpen() {
      return this.getAttribute('aria-hidden') === 'false';
    }

    open() {
      if (this.isOpen()) return;
      this.setAttribute('aria-hidden', 'false');
      // Don't lock body scroll while previewing in the theme editor —
      // the merchant should still be able to scroll the page behind.
      if (!this._editorPreview) {
        document.body.style.overflow = 'hidden';
      }
      // Focus the email input — { preventScroll: true } stops the browser
      // from scrolling the page to bring the input into view (would cause
      // the page to jump to the bottom while the popup is still animating in).
      // Skipped in editor preview to avoid stealing focus from the settings panel.
      if (!this._editorPreview) {
        setTimeout(() => {
          this.querySelector('[data-popup-email]')?.focus({ preventScroll: true });
        }, 400);
      }
    }

    close(markDismissed = false) {
      if (!this.isOpen()) return;
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (markDismissed) this._markDismissed();
    }

    _shouldShow() {
      if (this.frequency === 'always') return true;
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return true;
        const data = JSON.parse(raw);
        if (data.dismissed !== true) return true;
        if (this.frequency === 'session') return false;
        if (this.frequency === 'days') {
          const daysElapsed = (Date.now() - data.at) / (1000 * 60 * 60 * 24);
          return daysElapsed >= this.frequencyDays;
        }
        return false;
      } catch {
        return true;
      }
    }

    _markDismissed() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({
          dismissed: true,
          at: Date.now()
        }));
      } catch {}
    }

    _setupTimer() {
      this._timer = setTimeout(() => this.open(), this.timerDelay);
    }

    _setupExitIntent() {
      // Desktop: mouse leaves viewport from the top
      // Also arms the timer after 15s as fallback if mouse doesn't leave
      let armed = false;
      const onMouseOut = (e) => {
        if (armed) return;
        if (e.clientY <= 0 && !e.relatedTarget) {
          armed = true;
          this.open();
          document.removeEventListener('mouseout', onMouseOut);
        }
      };
      document.addEventListener('mouseout', onMouseOut, { signal: this._signal });

      // On mobile (no hover), fall back to scroll_up
      if (matchMedia('(pointer: coarse)').matches) {
        this._setupScrollUp();
      }
    }

    _setupScrollDepth() {
      let armed = false;
      const onScroll = () => {
        if (armed) return;
        const scrolled = window.scrollY + window.innerHeight;
        const total = document.documentElement.scrollHeight;
        const pct = (scrolled / total) * 100;
        if (pct >= this.scrollThreshold) {
          armed = true;
          this.open();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal: this._signal });
    }

    _setupScrollUp() {
      // Fires when the user scrolls up after scrolling down at least 500px
      let lastY = window.scrollY;
      let reachedDown = false;
      let armed = false;
      const onScroll = () => {
        if (armed) return;
        const y = window.scrollY;
        if (y > 500) reachedDown = true;
        if (reachedDown && y < lastY - 40) {
          armed = true;
          this.open();
          window.removeEventListener('scroll', onScroll);
        }
        lastY = y;
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal: this._signal });
    }

    async _copyDiscount() {
      if (!this.discountCode || !this.discountCopyBtn) return;
      try {
        await navigator.clipboard.writeText(this.discountCode);
      } catch {
        // Fallback
        const ta = document.createElement('textarea');
        ta.value = this.discountCode;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch {}
        ta.remove();
      }
      this.discountCopyBtn.classList.add('is-copied');
      setTimeout(() => this.discountCopyBtn.classList.remove('is-copied'), 2000);
    }

    disconnectedCallback() {
      this._ac?.abort();
      clearTimeout(this._timer);
    }
  }
  customElements.define('lytta-newsletter-popup', LyttaNewsletterPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-shop-product"]) return;
  try {
    
  (function() {
    const container = document.currentScript?.closest('.quick-shop-product');
    if (!container) return;

    /* Thumbnail switcher */
    const featured = container.querySelector('[data-quick-shop-featured]');
    const thumbs = container.querySelectorAll('[data-quick-shop-thumb]');
    if (featured && thumbs.length > 0) {
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const url = thumb.dataset.imageUrl;
          if (!url) return;
          featured.src = url;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }

    /* Variant image sync moved to assets/theme.js (LyttaQuickShop)
       because the section's javascript block isn't executed
       when the modal injects this template via innerHTML — HTML
       spec scopes innerHTML-inserted scripts as inert. */

    /* Update option-current display when variant changes */
    container.querySelectorAll('input[type="radio"][data-option]').forEach(input => {
      input.addEventListener('change', () => {
        const optIdx = input.dataset.option?.replace('option', '');
        if (!optIdx) return;
        const display = container.querySelector(`[data-option-current][data-option-index="${optIdx}"]`);
        if (display) display.textContent = input.value;
      });
    });

    /* Live recompute pay note on variant change */
    const payNote = container.querySelector('[data-pay-note]');
    if (payNote) {
      const tpl = payNote.dataset.template;
      const installments = parseInt(payNote.dataset.installments, 10) || 3;
      const minPrice = parseInt(payNote.dataset.minPrice, 10) || 0;

      function formatMoney(cents) {
        if (window.lytta?.settings?.moneyFormat) {
          const value = (cents / 100).toFixed(2).replace('.', ',');
          return window.lytta.settings.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
        }
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }

      container.addEventListener('lytta:variant:changed', (e) => {
        const variant = e.detail?.variant;
        if (!variant) return;
        if (minPrice > 0 && variant.price < minPrice) {
          payNote.style.display = 'none';
          return;
        }
        payNote.style.display = '';
        const installmentPrice = formatMoney(variant.price / installments);
        const html = (tpl || '')
          .replace(/\{installments\}/g, installments)
          .replace(/\{installment\}/g, installmentPrice)
          .replace(/\{price\}/g, formatMoney(variant.price));
        payNote.innerHTML = html;
      });
    }

    /* Stock shipping cutoff (mirrors main-product) */
    const stockEl = container.querySelector('[data-product-stock][data-cutoff-hour]');
    if (stockEl) {
      const cutoffHour = parseInt(stockEl.dataset.cutoffHour, 10);
      const cutoffTime = stockEl.dataset.cutoffTime || `${cutoffHour}:00`;
      const skipWeekends = stockEl.dataset.skipWeekends === 'true';
      const msgBefore = stockEl.dataset.msgBefore || '';
      const msgAfter = stockEl.dataset.msgAfter || '';
      const target = stockEl.querySelector('[data-shipping-msg]');
      if (target && !isNaN(cutoffHour)) {
        const now = new Date();
        const day = now.getDay();
        let useBefore = now.getHours() < cutoffHour;
        if (skipWeekends && (day === 0 || day === 6)) useBefore = false;
        const tpl = useBefore ? msgBefore : msgAfter;
        target.innerHTML = tpl.replace(/\{time\}/g, `<strong>${cutoffTime}</strong>`);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-lookbook"] && !Shopify.designMode) return;
  try {
    
  class LyttaLookbook extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const signal = this._ac.signal;

      this.canvas = this.querySelector('[data-lookbook-canvas]');
      this.triggers = this.querySelectorAll('[data-hotspot-trigger]');
      this.popovers = this.querySelectorAll('[data-hotspot-popover]');
      this.closeBtns = this.querySelectorAll('[data-hotspot-close]');
      this._openId = null;

      // Mobile backdrop (shared across all popovers in this lookbook)
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'lookbook__backdrop';
      document.body.appendChild(this.backdrop);
      this.backdrop.addEventListener('click', () => this.close());

      this.triggers.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const id = btn.dataset.hotspotTrigger;
          if (this._openId === id) this.close();
          else this.open(id);
        });
      });

      this.closeBtns.forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this._openId) return;
        if (e.target.closest('[data-hotspot-popover]')) return;
        if (e.target.closest('[data-hotspot-trigger]')) return;
        this.close();
      }, { signal });

      // Close on Esc
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this._openId) this.close();
      }, { signal });
    }

    open(id) {
      if (this._openId) this.close();

      const trigger = this.querySelector(`[data-hotspot-trigger="${CSS.escape(id)}"]`);
      const popover = this.querySelector(`[data-hotspot-popover="${CSS.escape(id)}"]`);
      if (!trigger || !popover) return;

      trigger.setAttribute('aria-expanded', 'true');
      popover.removeAttribute('hidden');
      this._openId = id;

      // Auto-flip on desktop so popover doesn't overflow the canvas
      if (window.matchMedia('(min-width: 601px)').matches) {
        this._autoFlip(popover);
      } else {
        // Mobile: show backdrop
        this.backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    }

    close() {
      if (!this._openId) return;
      const trigger = this.querySelector(`[data-hotspot-trigger="${CSS.escape(this._openId)}"]`);
      const popover = this.querySelector(`[data-hotspot-popover="${CSS.escape(this._openId)}"]`);
      trigger?.setAttribute('aria-expanded', 'false');
      popover?.setAttribute('hidden', '');
      popover?.classList.remove('is-flipped-top', 'is-flipped-bottom');
      this._openId = null;

      this.backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    _autoFlip(popover) {
      const pos = popover.dataset.position;
      if (pos && pos !== 'auto') return; // merchant chose explicit position

      // Default position is above the pin. If the popover would overflow the top
      // of the canvas, flip it below.
      const canvasRect = this.canvas.getBoundingClientRect();
      const popRect = popover.getBoundingClientRect();

      // The popover is rendered translated above by default; check if top is clipped
      const top = popRect.top;
      if (top < canvasRect.top + 10) {
        popover.classList.add('is-flipped-top');
      } else {
        popover.classList.add('is-flipped-bottom');
      }
    }

    disconnectedCallback() {
      this._ac?.abort();
      this.backdrop?.remove();
    }
  }
  customElements.define('lytta-lookbook', LyttaLookbook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class LyttaSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.current = 0;
      this.total = this.slides.length;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) || 5000;
      this._timer = null;
      this._isDragging = false;
      this._startX = 0;

      if (this.total <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dot)));
      });

      // Touch/swipe
      this.addEventListener('touchstart', (e) => { this._startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const diff = this._startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
      });

      // Keyboard
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());

      this.style.setProperty('--autoplay-speed', `${this.speed}ms`);
      this.play();
    }

    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');

      this.current = (index + this.total) % this.total;

      this.slides[this.current].classList.add('is-active');
      this.dots[this.current]?.classList.add('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'true');

      this.applyParallax();
    }

    next() { this.goTo(this.current + 1); this.resetTimer(); }
    prev() { this.goTo(this.current - 1); this.resetTimer(); }

    play() {
      if (!this.autoplay) return;
      this._timer = setInterval(() => this.next(), this.speed);
    }

    pause() { clearInterval(this._timer); }
    resetTimer() { this.pause(); this.play(); }

    applyParallax() {
      const activeImg = this.slides[this.current].querySelector('.slideshow__img');
      if (activeImg) activeImg.style.transform = 'translateY(0)';
    }

    disconnectedCallback() {
      // Stop the autoplay interval when the section is removed (theme
      // editor section reload, navigation, etc) — leaving it running
      // throws "Cannot read property of null" when goTo() runs against
      // detached DOM nodes.
      this.pause();
    }
  }
  customElements.define('lytta-slideshow', LyttaSlideshow);

  // Parallax on scroll — gated by per-section setting and reduced-motion
  const slideshowEl = document.querySelector('lytta-slideshow');
  const parallaxEnabled =
    slideshowEl?.dataset.parallax === 'true' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (slideshowEl && parallaxEnabled) {
    window.addEventListener('scroll', () => {
      const img = slideshowEl.querySelector('.slideshow__slide.is-active .slideshow__img');
      if (!img) return;
      // Lo scorrimento della PAGINA non dice nulla su dove sia questa
      // sezione: piu' in basso sta, piu' grande e' il numero. Con
      // `scrollY * 0.3` una fascia a 4.400px dall'inizio riceveva uno
      // spostamento di 1.300px e l'immagine usciva del tutto dal riquadro,
      // lasciando la fascia vuota. Quello che conta e' quanto la sezione si
      // e' mossa rispetto al centro dello schermo.
      const r = slideshowEl.getBoundingClientRect();
      const centro = r.top + r.height / 2 - window.innerHeight / 2;
      // L'immagine e' alta il 110%: c'e' un 10% di margine, e nessuno spostamento
      // puo' superarne la meta' senza scoprire un bordo. Il limite non e' una
      // precauzione, e' la condizione perche' l'effetto resti invisibile.
      const massimo = r.height * 0.05;
      const spostamento = Math.max(-massimo, Math.min(massimo, -centro * 0.08));
      img.style.transform = `translateY(${spostamento.toFixed(1)}px)`;
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class LyttaTestimonials extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const signal = this._ac.signal;

      this.track = this.querySelector('[data-testimonial-track]');
      if (!this.track) return; // grid layout – nothing to do

      this.slides = this.querySelectorAll('[data-testimonial-slide]');
      this.prevBtn = this.querySelector('[data-testimonial-prev]');
      this.nextBtn = this.querySelector('[data-testimonial-next]');
      this.dots = this.querySelectorAll('[data-testimonial-dot]');
      this.viewport = this.querySelector('[data-testimonial-viewport]');

      this.current = 0;
      this.total = this.slides.length;
      this.cardsPerView = 1;
      this.maxIndex = 0;
      this._autoplayTimer = null;

      this._updateCardsPerView();

      this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.testimonialDot, 10)));
      });

      // Swipe support
      let startX = 0;
      this.viewport?.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.viewport?.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) this.go(this.current + (dx < 0 ? 1 : -1));
      });

      // Resize: recompute cardsPerView (mobile→desktop and back) and
      // re-apply the transform so the carousel snaps to a valid index.
      window.addEventListener('resize', () => {
        this._updateCardsPerView();
        this.go(this.current);
      }, { signal, passive: true });

      // Autoplay
      if (this.dataset.autoplay === 'true' && this.total > 1) {
        this._startAutoplay();
        this.addEventListener('mouseenter', () => this._stopAutoplay());
        this.addEventListener('mouseleave', () => this._startAutoplay());
      }

      // Pause when off-screen
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(entries => {
          entries.forEach(e => {
            if (!e.isIntersecting) this._stopAutoplay();
            else if (this.dataset.autoplay === 'true') this._startAutoplay();
          });
        });
        this._io.observe(this);
      }
    }

    /**
     * Compute how many cards fit in the visible viewport at the
     * current breakpoint, then derive the maximum valid scroll index.
     *
     * Why this matters: the desktop CSS shows 2 cards per slide
     * (flex: 0 0 50%) but the old JS advanced 100% per click and had
     * one dot per card. With 4 cards → 4 dots but only 3 valid
     * positions (cards 1-2, 2-3, 3-4). The 4th dot translated to
     * -300% and showed half-card + empty space.
     *
     * Fix: maxIndex = total - cardsPerView. Step% = 100/cardsPerView.
     * Hide dots that point past maxIndex.
     */
    _updateCardsPerView() {
      if (!this.slides.length || !this.viewport) {
        this.cardsPerView = 1;
        this.maxIndex = 0;
        return;
      }
      const cardWidth = this.slides[0].getBoundingClientRect().width;
      const viewportWidth = this.viewport.getBoundingClientRect().width;
      this.cardsPerView = cardWidth > 0
        ? Math.max(1, Math.round(viewportWidth / cardWidth))
        : 1;
      this.maxIndex = Math.max(0, this.total - this.cardsPerView);

      // Hide dots past maxIndex. Using inline display so the rule beats
      // any CSS that might force visibility.
      this.dots.forEach((dot, i) => {
        dot.style.display = i > this.maxIndex ? 'none' : '';
      });

      // If the carousel has no scroll room (every card already visible),
      // hide nav controls entirely — they'd be no-ops.
      const noScroll = this.maxIndex === 0;
      if (this.prevBtn) this.prevBtn.style.display = noScroll ? 'none' : '';
      if (this.nextBtn) this.nextBtn.style.display = noScroll ? 'none' : '';
    }

    go(index) {
      if (this.total === 0) return;
      // wrap-around within the valid index range (0 ... maxIndex inclusive)
      const length = this.maxIndex + 1;
      this.current = ((index % length) + length) % length;
      const stepPercent = 100 / this.cardsPerView;
      this.track.style.transform = `translateX(-${this.current * stepPercent}%)`;
      this.dots.forEach((d, i) => {
        d.setAttribute('aria-selected', String(i === this.current));
      });
    }

    _startAutoplay() {
      this._stopAutoplay();
      const speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this._autoplayTimer = setInterval(() => this.go(this.current + 1), speed);
    }

    _stopAutoplay() {
      clearInterval(this._autoplayTimer);
      this._autoplayTimer = null;
    }

    disconnectedCallback() {
      this._ac?.abort();
      this._io?.disconnect();
      this._stopAutoplay();
    }
  }
  customElements.define('lytta-testimonials', LyttaTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-background"] && !Shopify.designMode) return;
  try {
    
  class LyttaVideoBg extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video.video-bg__video');
      this.toggleBtn = this.querySelector('[data-video-mute-toggle]');

      // Mark as playing once the video starts (fades out preload poster)
      if (this.video) {
        this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });

        // Some browsers block autoplay; nudge it once the section is in view
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(entries => {
            entries.forEach(e => {
              if (e.isIntersecting) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            });
          }, { threshold: 0.1 });
          io.observe(this);
        }
      }

      // Mute toggle
      this.toggleBtn?.addEventListener('click', () => {
        if (!this.video) return;
        this.video.muted = !this.video.muted;
        this.toggleBtn.setAttribute('aria-pressed', String(this.video.muted));
      });
    }
  }
  customElements.define('lytta-video-bg', LyttaVideoBg);

  } catch(e) { console.error(e); }
})();
})();
